'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdFiberSmartRecord = function MdFiberSmartRecord(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28.4 7.1q4.3 1.1 7.1 4.7t2.9 8.2-2.9 8.2-7.1 4.7v-3.4q2.9-1.1 4.8-3.6t1.8-5.9-1.8-5.9-4.8-3.6v-3.4z m-26.8 12.9q0-5.5 4-9.4t9.4-4 9.4 4 4 9.4-4 9.4-9.4 4-9.4-4-4-9.4z' })
        )
    );
};

exports.default = MdFiberSmartRecord;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/fiber-smart-record.js
// module id = 2309
// module chunks = 0